export const RGB_COLOR_REG = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/g
export const HEX_COLOR_REG = /#(?:[0-9a-fA-F]{6})/g

